/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const rsvp = /* GraphQL */ `
  mutation Rsvp($Content: RSVPInput) {
    rsvp(Content: $Content)
  }
`;
